import React, { useEffect, useState } from "react";
import '../EstadisticaDeOperadores.scss'
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { getRutasExcluidas } from "../integracion";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import BotonDescargarExel from "../../../../components/atoms/BotonDescargarExel/BotonDescargarExel";



const ModalRutasExcluidas = ({ isOpen, setIsOpen }) => {
    const [rutasExcluidas, setRutasExcluidas] = useState([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    useEffect(()=>{
        getRutasExcluidas().then((res)=>{
            setRutasExcluidas(res)
        })
    },[])

    
    return (

        <Dialog header="Rutas excluidas" visible={isOpen} style={{ width: '50vw' }} onHide={() => setIsOpen(false)}>
            <div className="EstadisticaDeOperadoresModalDescripcion">Aquí se mostrarán todas las rutas que no aplican para el bono.</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <InputText
                    value={globalFilterValue}
                    onChange={(e) => setGlobalFilterValue(e.target.value)}
                    placeholder="Buscar..."
                />
                <BotonDescargarExel nombreArchivo="Rutas_Excluidas" datos={rutasExcluidas} />
            </div>
            <DataTable value={rutasExcluidas} paginator rows={10} responsiveLayout="scroll" globalFilter={globalFilterValue}>
                <Column field="ID" header="ID"></Column>
                <Column field="NOMBRE" header="Ruta"></Column>
            </DataTable>

        </Dialog>

    );
}
export default ModalRutasExcluidas


